<template>
  <div :onClick="redirectCampaignDetail" v-bind:class="`${props.campaign.expired ? 'bloc-campaign bloc-campaign-expired' : 'bloc-campaign bloc-campaign-active'}`">
    <div class="bloc-campaign-information">
      <div class="campaign-information">
        <div class="campaign-event-icon">
          <SocialEventIcon :event="props.campaign.socialEvent" />
        </div>
        <div class="campaign-information-text">
          <div v-if="props.campaign.name.length < 20 " class="campaign-name">
            {{ $props.campaign.name }}
          </div>
          <div  v-else class="campaign-name tooltip">
            {{ $props.campaign.name.substr(0, 18) }}...
            <span class="tooltiptext">{{ $props.campaign.name }}</span>
          </div>
          <div class="campaign-validity">
            {{ $t("campaign.validityFrom") }} {{ props.campaign.startDate }} {{ $t("campaign.validityTo") }} {{ props.campaign.endDate }}
          </div>
        </div>
      </div>
      <div class="campaign-icon-detail">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M9 18L15 12L9 6" stroke="#0B1C48" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
    <div v-if="null !== props.campaign.amount" class="bloc-campaign-amount">
      <div class="flex justify-between mb-1 bloc-campaign-amount-numbers">
        <span class="campaign-amount" :class="{ 'campaign-amount-zero': 0 == props.campaign.amount }">{{ props.campaign.amount.toLocaleString('fr-FR', { minimumFractionDigits: 2 }) }}€</span>
        <span class="campaign-amount-total">{{ props.campaign.totalAmount.toLocaleString('fr-FR', { minimumFractionDigits: 2 }) }}€</span>
      </div>
      <div class="campaign-amount-progress w-full bg-gray-200 rounded-full h-2.5">
        <div class="campaign-amount-progress bg-blue-600 h-2.5 rounded-full" :style="{width: (props.campaign.amount/props.campaign.totalAmount*100) + '%'}"></div>
      </div>
    </div>
    <div v-else class="bloc-campaign-status-expired">
      Campagne expirée
    </div>
  </div>
</template>

<script setup>
  import SocialEventIcon from "@/components/Campaign/SocialEvent3DIcon.vue";
  import router from "@/router";

  const props = defineProps({
    'campaign': {
      type: Object,
      default: () => ({
        uuid: null,
        name: null,
        socialEvent: null,
        startDate: null,
        endDate: null,
        amount: null,
        totalAmount: null,
        expired: null
      })
    }
  })

  const redirectCampaignDetail = () => {
    router.push('/admin/campaigns/' + props.campaign.uuid);
  }
</script>

<style scoped lang="scss">
  .bloc-campaign {
    display: flex;
    padding: 24px 32px;
    flex-direction: column;
    align-items: center;
    flex: 1 0 0;
    border-radius: 20px;
    cursor: pointer;

    .bloc-campaign-information {
      width: 100%;
      display: flex;
      justify-content: space-between;
      gap: 8px;

      .campaign-information {
        display: flex;
        justify-content: flex-start;
        gap: 5px;

        .campaign-event-icon {
          margin: auto;
          width: 36px;
          height: 36px;

          img {
            width: 36px;
            height: 36px;
          }
        }

        .campaign-information-text {
          text-align: left;
        }

        .campaign-name {
          text-align: left;
          color: #0B1C48;
          font-size: 16px;
          font-weight: 700;
        }

        .campaign-validity {
          margin-top: 5px;
          width: 100%;
          color: rgba(11, 28, 72, 0.50);
          font-size: 10px;
          font-weight: 400;
          text-align: left;
        }
      }

      .campaign-icon-detail {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .bloc-campaign-amount {
      margin-top: 20px;
      width: 100%;
      text-align: center;

      .bloc-campaign-amount-numbers {
        display: flex;
        align-items: flex-end;
        gap: 35px;
        align-self: stretch;

        .campaign-amount {
          color: #275CF1;
          font-size: 16px;
          font-weight: 700;
        }

        .campaign-amount-zero {
          color: rgba(11, 28, 72, 0.50);
        }

        .campaign-amount-total {
          color: rgba(11, 28, 72, 0.50);
          text-align: right;
          font-size: 10px;
          font-weight: 400;
        }
      }

      .campaign-amount-progress {
        height: 4px;
      }
    }

    .bloc-campaign-status-expired {
      margin-top: 30px;
      width: 100%;
      text-align: center;
      color: rgba(11, 28, 72, 0.50);
      font-size: 14px;
      font-weight: 700;
    }
  }

  .bloc-campaign-active {
    border: 1px solid rgba(39, 92, 241, 0.10);
    background: #FFF;
  }

  .bloc-campaign-expired {
    border: 1px solid rgba(11, 28, 72, 0.06);
    background: linear-gradient(0deg, rgba(11, 28, 72, 0.02) 0%, rgba(11, 28, 72, 0.02) 100%), #FFF;
  }
</style>
